var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "google_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.84.06H0v23.88h31.84V.06Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#google_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.171 23.94h5.066V11.638L0 6.211v15.558a2.17 2.17 0 0 0 2.171 2.171Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.604 23.94h5.066a2.17 2.17 0 0 0 2.17-2.17V6.21l-7.236 5.428",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.604 2.23v9.408l7.237-5.427V3.316c0-2.685-3.065-4.215-5.21-2.605",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.237 11.638V2.231l8.683 6.512 8.684-6.512v9.407l-8.684 6.513",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.316v2.895l7.237 5.427V2.231L5.21.71C3.061-.9 0 .63 0 3.316Z",
    fill: "#C5221F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.06,
    width: 32,
    height: 23.881,
    rx: 5,
    fill: "#fff"
  })))));
};
export default SvgGoogle;